import { render, staticRenderFns } from "./CreateBankingOffice.vue?vue&type=template&id=40f8754b&scoped=true"
import script from "./CreateBankingOffice.vue?vue&type=script&lang=js"
export * from "./CreateBankingOffice.vue?vue&type=script&lang=js"
import style0 from "./CreateBankingOffice.vue?vue&type=style&index=0&id=40f8754b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f8754b",
  null
  
)

export default component.exports